import React from 'react';
import PropTypes from 'prop-types';
import { Events, getSegmentModelMetadata, handleAnalytics } from '@foxcorp/delta-web-analytics';
import CarouselV2 from 'componentsV2/Carousel';
import Grid from 'componentsV2/Grid';
import { Poster, SIMPLIFIED } from 'componentsV2/Poster';
import { getSitePlatform, isMobileBreakpoint } from 'helpers/BreakpointHelper';
import getShowPanelProps from '../../PersonalityProcessor';

import Style from './ShowPanel.module.scss';

const ShowPanel = ({ collections = [], favoritesManager }) => {
  const collectionCount = collections?.length;
  if (collectionCount === 0) return null;
  const breakpoint = getSitePlatform();
  const collection = collections?.[0];
  const items = collection?.items?.member;

  const onPosterClick = ({ item, index }) => {
    const modelMetaData = item?.trackingData?.properties?.modelMetaData;
    handleAnalytics({
      event: Events.PLAYLIST_BUTTON_ACTION,
      payload: {
        page_action_type: 'Watch',
        page_item_title: item?.name,
        page_item_subtitle: item?.description,
        page_action_location: 'Personalities',
        page_item_vertical_position: 1,
        page_item_horizontal_position: index + 1,
        page_playlist_length: items?.length,
        page_collection_count: collectionCount,
        page_collection_id: collection?.id,
        page_video_uid: item?.guid || item?.showCode,
        page_recs_source_id: modelMetaData?.sourceId ?? ' ',
        page_recs_configuration_id: modelMetaData?.configurationId ?? ' ',
        page_recs_result_set_id: modelMetaData?.resultSetId ?? ' ',
        page_recs_collection_model_id: modelMetaData?.modelId ?? ' ',
        page_recs_collection_request_id: modelMetaData?.requestId ?? ' ',
        page_recs_collection_result_set_id: modelMetaData?.resultSetId ?? ' ',
        page_recs_collection_source_id: modelMetaData?.sourceId ?? ' ',
        ...getSegmentModelMetadata(),
      },
    });
  };

  const desktopItems = () => (
    <CarouselV2 type="poster">
      {items?.map((item, index) => (
        <Poster
          breakpoint={breakpoint}
          favoritesManager={favoritesManager}
          itemIndex={index}
          onPosterClick={() => onPosterClick({ item, index })}
          type={SIMPLIFIED}
          {...getShowPanelProps({ item })}
        />
      ))}
    </CarouselV2>
  );
  const mobileItems = () => (
    <Grid theme={Style} type="poster">
      {items?.map((item, index) => (
        <Poster
          breakpoint={breakpoint}
          favoritesManager={favoritesManager}
          isGrid
          item={item}
          itemIndex={index}
          onPosterClick={() => onPosterClick({ item, index })}
          type={SIMPLIFIED}
          {...getShowPanelProps({ item })}
        />
      ))}
    </Grid>
  );

  return (
    <section className={Style.container}>
      {isMobileBreakpoint(breakpoint) ? mobileItems() : desktopItems()}
    </section>
  );
};

ShowPanel.propTypes = {
  collections: PropTypes.arrayOf(PropTypes.shape({})),
  favoritesManager: PropTypes.shape({}),
  getShowPanelProps: PropTypes.shape({}),
};

export default ShowPanel;
